import Vue from 'vue'

import { CustomNav, CustomFooter, Card, Carousel } from '@/components'
import { ImprintContent, PrivacyPolicyContent } from '@/markdown'

// components
Vue.component('custom-nav', CustomNav)
Vue.component('custom-footer', CustomFooter)
Vue.component('carousel', Carousel)
Vue.component('card', Card)

// markdown content
Vue.component('imprint-content', ImprintContent)
Vue.component('privacy-policy-content', PrivacyPolicyContent)
